import { Component, OnDestroy, ViewEncapsulation } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";
import { Subject } from "rxjs";

@Component({
  selector: "empty-layout",
  templateUrl: "./empty.component.html",
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule, FuseLoadingBarComponent],
  standalone: true,
})
export class EmptyLayoutComponent implements OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
